import dynamic from "next/dynamic"

export const templateMapping = {
  article: dynamic(() => import("@/templates/article/article")),
  page: dynamic(() => import("@/templates/page/page")),
  archive: dynamic(() => import("@/templates/archive/archive")),
  error: dynamic(() => import("@/templates/error/error")),
  protected: dynamic(() => import("@/templates/protected/protected"))
}
